import { createContext, useContext, useState, useCallback } from 'react';

const TOKEN_KEY = 'arq_token';
// Fallback é URL pública (NUNCA localhost/IP local — se o build perder a env var,
// o app tem que continuar acessível pelo público real, não só pela LAN do dev).
// Padrão Centrão: ver centrao-docs/padroes/06-frontend-react.md
const API_URL = process.env.REACT_APP_API_URL || 'https://api-arquitetos.centraomateriais.com';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) { localStorage.removeItem(TOKEN_KEY); return null; }
      return payload;
    } catch {
      return null;
    }
  });

  const login = useCallback(async (username, senha) => {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, senha }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao fazer login');
    localStorage.setItem(TOKEN_KEY, data.token);
    const payload = JSON.parse(atob(data.token.split('.')[1]));
    setUser(payload);
    return payload;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  const temPermissao = useCallback((nome) => {
    return user?.permissoes?.includes(nome) ?? false;
  }, [user]);

  const getToken = useCallback(() => localStorage.getItem(TOKEN_KEY), []);

  return (
    <AuthContext.Provider value={{ user, login, logout, temPermissao, getToken, apiUrl: API_URL }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
